import React from "react";
import { connect } from "react-redux";

import ReactTable from "react-table";
import Datetime from "react-datetime";
// react-select
import Select from "react-select";

import { getIntentosForTable, getIntentoDetalle, limpiarIntento } from "../../../store/actions/autorizarActions";
import { getIntentosTotal } from "../../../store/actions/notificacionesActions";
import { getSucursales } from "../../../store/actions/catalogoSucursalActions";
import { ACCION_INTENTO_ENTREGA } from "../../../push/firebaseMessaging";

import IntentoDetalle from "./IntentoDetalle.js";
import { chipIntento, textosTabla } from "./comunes.js";

// core components
import GridContainer from "components/Grid/GridContainer.js";
import GridItem from "components/Grid/GridItem.js";
import Button from "components/CustomButtons/Button.js";
import Card from "components/Card/Card.js";
import CardBody from "components/Card/CardBody.js";
import CustomInput from "components/CustomInput/CustomInput.js";
import Spinner from "components/Spinner/Spinner.js";

import InputLabel from "@material-ui/core/InputLabel";
import FormControl from "@material-ui/core/FormControl";

import moment from 'moment';
import "moment/locale/es";

// @material-ui/core components
import { makeStyles } from "@material-ui/core/styles";
import VisibilityIcon from '@material-ui/icons/Visibility';
import RefreshIcon from '@material-ui/icons/Refresh';

import styles from "assets/jss/material-dashboard-pro-react/views/extendedTablesStyle.js";

const useStyles = makeStyles(styles);

const formatoApi = (fecha) => moment(fecha).format("YYYY-MM-DD");
const esHoy = (fecha) => moment(fecha).isSame(moment(), "day");

// Pestana principal del modulo: tablero de SOLO LECTURA de los intentos de entrega que
// registran los choferes desde la app (motivo + foto + GPS; maximo 2 por guia y reparto).
// Cada sucursal ve los suyos (el API impone la del JWT); matriz ve todos y puede filtrar
// por sucursal. Aqui no se autoriza ni se rechaza nada: la devolucion la hace almacen.
function IntentosTab(props) {

    const classes = useStyles();

    const [esmatriz] = React.useState(localStorage.getItem("esmatriz") === "s");

    // filtros: fecha (hoy por defecto), guia y sucursal (solo matriz; null = todas)
    const [fecha, setFecha] = React.useState(moment());
    const [guiaFiltro, setGuiaFiltro] = React.useState("");
    const [sucursal, setSucursal] = React.useState(null);

    // modal de detalle del intento
    const [modalOpen, setModalOpen] = React.useState(false);

    const [loading, setLoading] = React.useState(false);

    const buscar = (vFecha, vGuia, vSucursal, conSpinner) => {
        if (conSpinner !== false) { setLoading(true); }
        props.getIntentosForTable(
            formatoApi(vFecha),
            vGuia.trim() !== "" ? vGuia.trim() : null,
            vSucursal ? vSucursal.value : null
        );
    };

    // gets data when component did mount: intentos de hoy; matriz ademas necesita el
    // catalogo de sucursales para el filtro (la navbar suele haberlo cargado ya)
    React.useEffect(() => {
        buscar(fecha, guiaFiltro, sucursal);
        if (esmatriz && props.sucursalesList == null) {
            props.getSucursales();
        }
    }, []);

    // push "intento de entrega" (FCM Web) con la vista abierta: se resincroniza el total
    // de la campanita con el API y, si el filtro es de hoy, se recarga el listado sin
    // spinner para no interrumpir lo que el usuario este viendo
    React.useEffect(() => {
        if (props.ultimoAviso == null || props.ultimoAviso.accion !== ACCION_INTENTO_ENTREGA) { return; }
        props.getIntentosTotal();
        if (esHoy(fecha)) {
            buscar(fecha, guiaFiltro, sucursal, false);
        }
    }, [props.ultimoAviso]);

    React.useEffect(() => {
        if (props.intentosData != null) { setLoading(false); }
    }, [props.intentosData]);

    // ante cualquier error del modulo apagar el spinner (el SweetAlert lo pinta Autorizar.js)
    React.useEffect(() => {
        if (props.MensajeError != null) { setLoading(false); }
    }, [props.MensajeError]);

    const handleFechaChange = (date) => {
        // el input es readOnly: solo llegan fechas (moment) del calendario
        if (!date || !moment.isMoment(date)) { return; }
        setFecha(date);
        buscar(date, guiaFiltro, sucursal);
    };

    const irAHoy = () => {
        const hoy = moment();
        setFecha(hoy);
        buscar(hoy, guiaFiltro, sucursal);
    };

    const handleSucursalChange = (selectedOption) => {
        const vSucursal = selectedOption || null;
        setSucursal(vSucursal);
        buscar(fecha, guiaFiltro, vSucursal);
    };

    // no hay intentos a futuro
    const validDateTimes = (current) => {
        const today = Datetime.moment();
        return current.isBefore(today);
    };

    const sucursalesStyles = {
        control: styles => ({ ...styles, marginTop: '27px' }),
        placeholder: styles => ({ ...styles, color: '#AAAAAA' }),
    };

    // ─── Modal de detalle del intento ────────────────────────────────────────

    const abrirIntento = (id) => {
        props.limpiarIntento();
        setModalOpen(true);
        props.getIntentoDetalle(id);
    };

    const cerrarIntento = () => {
        setModalOpen(false);
        props.limpiarIntento();
    };

    const intento = props.intentoData == null ? null : props.intentoData.resultado;

    // ─── Listado ─────────────────────────────────────────────────────────────

    const listData = props.intentosData == null ? null : props.intentosData.data;

    const formattedData = listData == null ? [] : (
        listData.map((prop) => {
            return {
                id: prop.id,
                fecha: prop.fecha,
                nombresucursal: prop.nombresucursal,
                folioreparto: prop.folioreparto,
                chofer: prop.chofer,
                unidad: prop.unidad,
                guia: prop.guia,
                intento: chipIntento(prop.numero, prop.maximo),
                motivo: prop.motivo,
                acciones: (
                    <div className="actions-right">
                        <Button color="success" className={classes.actionButton} onClick={() => {
                            abrirIntento(prop.id);
                        }}>
                            <VisibilityIcon className={classes.icon} />
                        </Button>{" "}
                    </div>
                )
            }
        })
    );

    const columnasIntentos = [
        { Header: "Id", accessor: "id", show: false },
        { Header: "Fecha", accessor: "fecha" },
        { Header: "Sucursal", accessor: "nombresucursal" },
        { Header: "Reparto", accessor: "folioreparto" },
        { Header: "Repartidor", accessor: "chofer" },
        { Header: "Unidad", accessor: "unidad" },
        { Header: "Guía", accessor: "guia" },
        { Header: "Intento", accessor: "intento", sortable: false, filterable: false },
        { Header: "Motivo", accessor: "motivo" },
        { Header: "Ver", accessor: "acciones", sortable: false, filterable: false },
    ];

    return (
        <React.Fragment>
            <div><Spinner width={"80%"} height={5} color={"black"} loading={loading} /></div>
            <GridContainer>
                <GridItem xs={12} sm={12} md={12}>
                    <Card>
                        <CardBody>
                            <GridContainer>
                                <GridItem xs={12} sm={12} md={2}>
                                    <InputLabel className={classes.label}>Fecha</InputLabel>
                                    <br />
                                    <FormControl fullWidth>
                                        <Datetime
                                            value={moment(fecha).format("DD/MM/YYYY")}
                                            locale="es"
                                            closeOnSelect
                                            timeFormat={false}
                                            inputProps={{
                                                placeholder: "Fecha",
                                                readOnly: true,
                                            }}
                                            onChange={handleFechaChange}
                                            isValidDate={validDateTimes}
                                        />
                                    </FormControl>
                                </GridItem>
                                <GridItem xs={12} sm={12} md={1}>
                                    <Button
                                        simple
                                        color="info"
                                        size="sm"
                                        style={{ marginTop: 32 }}
                                        onClick={irAHoy}
                                        disabled={esHoy(fecha)}
                                    >
                                        Hoy
                                    </Button>
                                </GridItem>
                                <GridItem xs={12} sm={12} md={3}>
                                    <CustomInput
                                        labelText="Guía"
                                        formControlProps={{ fullWidth: true }}
                                        inputProps={{
                                            autoComplete: "off",
                                            value: guiaFiltro,
                                            onChange: (event) => setGuiaFiltro(event.target.value),
                                            onKeyPress: (event) => {
                                                if (event.key === "Enter") {
                                                    event.preventDefault();
                                                    buscar(fecha, guiaFiltro, sucursal);
                                                }
                                            },
                                        }}
                                    />
                                </GridItem>
                                {esmatriz ? (
                                    <GridItem xs={12} sm={12} md={3}>
                                        <Select
                                            options={props.sucursalesList || []}
                                            isClearable
                                            isLoading={props.sucursalesList == null}
                                            onChange={handleSucursalChange}
                                            styles={sucursalesStyles}
                                            placeholder="Todas las sucursales"
                                            value={sucursal}
                                        />
                                    </GridItem>
                                ) : null}
                                <GridItem xs={12} sm={12} md={3}>
                                    <Button
                                        color="success"
                                        onClick={() => buscar(fecha, guiaFiltro, sucursal)}
                                        className={classes.registerButton}
                                    >
                                        <RefreshIcon className={classes.icon} /> Refrescar
                                    </Button>
                                </GridItem>
                            </GridContainer>
                        </CardBody>
                    </Card>
                </GridItem>
                <GridItem xs={12} sm={12} md={12}>
                    <Card>
                        <CardBody>
                            {listData == null ? (
                                <h4>Cargando informacion...</h4>
                            ) : (
                                <ReactTable
                                    data={formattedData}
                                    filterable
                                    defaultFilterMethod={(filter, row) => {
                                        const id = filter.pivotId || filter.id
                                        return row[id] !== undefined ? String(row[id]).toLowerCase().includes(filter.value.toLowerCase()) : true
                                    }}
                                    columns={columnasIntentos}
                                    defaultPageSize={20}
                                    showPaginationTop={false}
                                    showPaginationBottom
                                    className="-striped -highlight"
                                    {...textosTabla}
                                />
                            )}
                        </CardBody>
                    </Card>
                </GridItem>
            </GridContainer>
            <IntentoDetalle open={modalOpen} onClose={cerrarIntento} intento={intento} />
        </React.Fragment>
    );
}

const mapStateToProps = (state) => {
    return {
        "intentosData": state.autorizar.autorizar_Intentos,
        "intentoData": state.autorizar.autorizar_Intento,
        "MensajeError": state.autorizar.autorizar_Error_Message,
        "ultimoAviso": state.notificaciones.ultimoAviso,
        "sucursalesList": state.catalogosucursal.catalogoSucursal_List,
    }
}

const mapDispatchToProps = (dispatch) => {
    return {
        "getIntentosForTable": (fecha, guia, sucursal) => dispatch(getIntentosForTable(fecha, guia, sucursal)),
        "getIntentoDetalle": (id) => dispatch(getIntentoDetalle(id)),
        "limpiarIntento": () => dispatch(limpiarIntento()),
        "getIntentosTotal": () => dispatch(getIntentosTotal()),
        "getSucursales": () => dispatch(getSucursales()),
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(IntentosTab);
